import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { camelizeKeys } from "@/utils/object-functions";

export const useSearchParams = () => {
  const { search } = useLocation();

  return useMemo(
    () => camelizeKeys(Object.fromEntries(new URLSearchParams(search).entries())),
    [search]
  );
}
